import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

export function initBannerBlockSplide() {
    
    const sliders = document.querySelectorAll<HTMLElement>('.banner-block-splide');

    sliders.forEach((slider) => {
        const splide = new Splide(slider, {
            type: 'fade',
            rewind: true,
            perPage: 1,
            perMove: 1,
            autoplay: true,
            arrows: false,
            gap: '0px',
            speed: 2500,
        });

        splide.mount();
    });
}